// const head = 'http://localhost:3007/'
// const head = 'http://106.13.34.154:3007/'
const head = 'https://jbapi.yaodianma.com/'

// eslint-disable-next-line import/no-anonymous-default-export
export default head
